import { EContractorPaymentStatus } from "../../contractor-payments";
import { schemes, zSchema } from "../../schema-validation";
import { EContractorDisbursementMethod } from "../../workers-shared";
import { EWebhookType } from "../EWebhookType";

export const contractorPaymentWebhookSchema = zSchema.object({
  amount: zSchema.number(),
  approval_required: zSchema.boolean(),
  approved: zSchema.boolean(),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId(),
  contractorPaymentID: schemes.mongoObjectId(),
  disbursement: zSchema.object({
    method: zSchema.nativeEnum(EContractorDisbursementMethod),
    history: zSchema
      .array(
        zSchema.object({
          date: zSchema.string(),
          status: zSchema.string(),
        })
      )
      .default([]),
    status: zSchema.string(),
  }),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
  metadata: schemes.metadata(),
  middle_name: zSchema.string().nullable(),
  pay_date: schemes.isoDate(),
  status: zSchema.nativeEnum(EContractorPaymentStatus),
  test: zSchema.boolean(),
  timestamp: zSchema.string(),
  type: zSchema.nativeEnum(EWebhookType),
});

export type TContractorPaymentWebhook = zSchema.infer<
  typeof contractorPaymentWebhookSchema
>;
